export default __webpack_public_path__ + "static/media/icon1.5ba9bf90.svg";